<template>
  <Navbar />
</template>
<script>
import Navbar from "@/components/AllNavBar.vue";
// import store from "@/store";
export default {
  title: "Property",
  components: { Navbar },
  data() {
    return {
    //   r5: JSON.parse(store.state.randp.r5).create,
    };
  },
  async mounted() {
    // if (this.r5 != true) {
    //   this.$root.$router.push({
    //     path: "/SignIn",
    //   });
    // }
  },
  methods: {},
  watch: {},
};
</script>
